export default __webpack_public_path__ + "assets/img/Right_chev_act.9a652295.svg";